import { render, staticRenderFns } from "./Affluence.vue?vue&type=template&id=77b63a2e"
import script from "./Affluence.vue?vue&type=script&lang=ts"
export * from "./Affluence.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports